import React, { useState, useSelector } from "react";
import styles from "./Styles.module.css";
import StatusPill from "../../../components/Status/StatusPill.component";
import history from "../../../libs/history.utils";
import {
  ArrowPrimaryButton,
  OutlineButton,
  PrimaryButton,
} from "../../../components/Buttons/PrimaryButton";
import { Dialog, ButtonBase, Typography } from "@mui/material";
import { Add, ArrowBackIos, Lock } from "@mui/icons-material";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import useProgramDetailHook from "./ProgramDetailHook";
import UploadCsvDialog from "./component/UploadCsv/UploadCsvDialog.view";
import editTask from "../../../assets/CRMAssets/ic_edit@2x.png";
import { useTheme } from "@mui/styles";
import ProductTable from "./component/ProductList/ProductTable.component";
import ProductQuizTable from "./component/ProductQuizList/ProductQuizTable.component";
import ProductHealthTipsTable from "./component/ProductHealthTipsList/ProductHealthTips.component";
import ProductPetTable from "./component/ProductPetList/ProductPetTable.component";
import AssociatePetDialog from "./component/AssociatePet/AssociatePetDialog.view";
import UploadMyDocDialog from "./component/UploadMyDoc/UploadMyDocDialog.view";
import DocTable from "./component/DocList/DocTable.component";
import ProductRewardTable from "./component/ProductRewardList/ProductRewardTable.component";
import GiftStoreTable from "./component/GiftStoreList/GiftStoreTable.component";
import useRoles from "../../../hooks/RoleHook";
import Constants from "../../../config/constants";
const ProgramDetail = () => {
  const theme = useTheme();
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.PROGRAM_MANAGEMENT);
  const { canRead: canReadPetMaster, canCreate: canCreatePetMaster} = useRoles(Constants.MODULES.PET_MASTER);
  const {canDelete: canDeleteCode, canRead : canReadCode, canCreate: canCreateCode, canUpdate: canUpdateCode} = useRoles(Constants.MODULES.MYDOC_CODES);
  const {canDelete: canDeleteProCode, canRead : canReadProCode, canCreate: canCreateProCode, canUpdate: canUpdateProCode} = useRoles(Constants.MODULES.PROGRAM_PRODUCTS_CODES);
  const {canRead : canReadGift, canCreate: canCreateGift, canUpdate: canUpdateGift} = useRoles(Constants.MODULES.GIFT_STORE);
  const {canRead : canReadHealth, canCreate: canCreateHealth, canUpdate: canUpdateHealth} = useRoles(Constants.MODULES.HEALTH_TIPS_MASTER);
  const {canRead : canReadQuiz, canCreate: canCreateQuiz, canUpdate: canUpdateQuiz} = useRoles(Constants.MODULES.QUIZES_MODULE);
  const {canRead : canReadReward, canCreate: canCreateReward, canUpdate: canUpdateReward} = useRoles(Constants.MODULES.REWARDS_MASTER);
  const {
    programDetails,
    openDialog,
    closeDialog,
    isDialogOpen,
    handleEdit,
    handleSampleDownload,
    toggleCsvDialog,
    isCsvDialog,
    updateCsVList,
    handleCreate,
    renderList,
    renderRewardList,
    updateRewardList,
    togglePetDialog,
    isPetDialog,
    updatePetList,
    renderPetList,
    renderGiftList,
    updateGiftList,
    isMyDocDialog,
    updateMyDocList,
    renderMyDocList,
    toggleMyDocDialog,
    handleSampleMyDocDownload,
    handleHealthCreate,
  } = useProgramDetailHook({});

  const getStatusPillColor = () => {
    if (programDetails?.status === "ACTIVE") {
      return "active";
    } else if (programDetails?.status === "INACTIVE") {
      return "high";
    }
  };

  return (
    <div>
      <div>
        <div className={styles.upperFlex}>
          <ButtonBase onClick={() => history.push("/program")}>
            <ArrowBackIos fontSize={"small"} />{" "}
            <span>
              <Typography variant={"h4"}>Program Detail</Typography>
            </span>
          </ButtonBase>
          <div></div>
          <div className={styles.profileHeading}></div>
        </div>
        <>
          <div className={styles.row}>
            <UploadCsvDialog
              isOpen={isCsvDialog}
              handleToggle={toggleCsvDialog}
              handleCsvUpload={updateCsVList}
              // handleCsvUpload={handleCsvUpload}
            />
            {isMyDocDialog && (
              <UploadMyDocDialog
                isOpen={isMyDocDialog}
                handleToggle={toggleMyDocDialog}
                handleCsvUpload={updateMyDocList}
              />
            )}
            <AssociatePetDialog
              isOpen={isPetDialog}
              handleToggle={togglePetDialog}
              updatePetList={updatePetList}
            />
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row}>
                
                  <img
                    src={programDetails?.logo}
                    alt="Image"
                    className={styles.image}
                    crossOrigin="anonymous"
                  />
                 
                  <div className={styles.textContainer}>
                    <div className={styles.row1}>
                      <Typography
                        variant={"h5"}
                        className={styles.productHeading}
                        color={"text.primary"}
                      >
                        {programDetails?.name.charAt(0).toUpperCase() +
                          programDetails?.name.slice(1)}
                      </Typography>
                      <div className={styles.right}>
                        <StatusPill
                          status={
                            programDetails?.status === "INACTIVE"
                              ? "Inactive"
                              : "Active"
                          }
                          color={getStatusPillColor()}
                        />
                      </div>
                    </div>
                    <div className={styles.row1}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        {programDetails?.code ?? "N/A"}
                      </Typography>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                        sx={{ mt: 1 }}
                      >
                        <div className={styles.dateRow}>
                          <div>{programDetails?.startDateText ?? "N/A"}</div>
                          <div>{` - `}</div>
                          <div>{programDetails?.endDateText ?? "N/A"}</div>
                        </div>
                      </Typography>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        Privacy Policy URL:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        className={styles.link}
                        sx={{ ml: 1 }}
                      >
                        <a
                          href={programDetails?.privacy_policy_url}
                          target={"_blank"}
                        >
                          {programDetails?.privacy_policy_url ? (
                            <a
                              href={programDetails?.privacy_policy_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.urlColor}
                            >
                              {programDetails?.privacy_policy_url}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </a>
                      </Typography>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={`${styles.spacing} ${styles.url}`}
                      >
                        T&C URL:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        className={styles.link}
                        sx={{ ml: 1 }}
                      >
                        <a href={programDetails?.t_and_c_url} target={"_blank"}>
                          {" "}
                          {programDetails?.t_and_c_url ? (
                            <a
                              href={programDetails?.t_and_c_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.urlColor}
                            >
                              {programDetails?.t_and_c_url}
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </a>
                      </Typography>
                    </div>
                    <div className={styles.row}>
                      <>
                        <Typography
                          variant={"body1"}
                          color={"text.secondary"}
                          className={styles.spacing}
                        >
                          Location:
                        </Typography>
                        <Typography
                          variant={"subtitle1"}
                          color={"text.secondary"}
                          sx={{ ml: 1 }}
                        >
                          {/* {programDetails?.location_details?.is_pan_india
      ? "India" 
      : programDetails?.cities?.length > 0
      ? programDetails?.cities.map((city) => city.name).join(", ") 
      : programDetails?.states?.length > 0
      ? programDetails?.states.map((state) => state.name).join(", ")
      : "N/A"} */}
                          {programDetails?.location_details?.is_pan_india
                            ? "India"
                            : [
                                programDetails?.states
                                  ?.map((state) => state.name)
                                  .join(", ")
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" "),
                                programDetails?.cities
                                  ?.map((city) => city.name)
                                  .join(", ")
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" "),
                              ]
                                .filter(Boolean) // Removes any empty strings
                                .join(", ") || "N/A"}
                        </Typography>
                      </>
                    </div>
                    <div className={styles.row}>
                      <Typography
                        variant={"body1"}
                        color={"text.secondary"}
                        className={styles.spacing}
                      >
                        Manual Medicine Addition Allowed:
                      </Typography>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                        sx={{ ml: 1 }}
                      >
                        {programDetails?.is_manual_medicine ? "Yes" : "No"}
                      </Typography>
                    </div>
                  </div>
                </div>

                <div className={styles.company}>
                  <div className={styles.companyRow}>
                    <Typography variant={"body1"} sx={{ mr: 1, mt: 1 }}>
                      Powered By
                    </Typography>
                    {programDetails?.client && (
                      <>
                      
                        <img
                          src={programDetails?.client?.logo}
                          alt="cipla"
                          crossOrigin="anonymous"
                          className={styles.companyImg}
                        ></img>
                        <Typography variant={"body1"} sx={{ ml: 1, mt: 1 }}>
                          {programDetails?.client?.name?.toUpperCase()}
                        </Typography>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </ShadowBox>
          </div>
          <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <Typography
                  variant={"h5"}
                  className={styles.productHeading}
                  color={"text.primary"}
                >
                  {" "}
                  About the Program
                </Typography>
                <Typography
                  variant="body1"
                  color={"text.secondary"}
                  sx={{ marginTop: "-2.5px" }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: programDetails?.description,
                    }}
                  />
                </Typography>
              </div>
            </ShadowBox>
          </div>
          <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <Typography
                  variant={"h5"}
                  className={styles.productHeading}
                  color={"text.primary"}
                  sx={{ mb: 1 }}
                >
                  {" "}
                  Program Introductory Screens Content
                </Typography>
                {programDetails?.program_intro_contents.map(
                  (content, index) => (
                    <>
                      <Typography
                        variant={"subtitle1"}
                        color={"text.secondary"}
                      >
                        {" "}
                        {content.title}
                      </Typography>
                      <Typography variant={"body1"} color={"text.secondary"}>
                        {content.description}
                      </Typography>
                      {index <
                        programDetails.program_intro_contents.length - 1 && (
                        <div className={styles.line} />
                      )}
                    </>
                  )
                )}
              </div>
            </ShadowBox>
          </div>
          {(canCreateProCode  || canUpdateProCode )  && (<div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {" "}
                    Program Master Details
                  </Typography>
                  <div className={`${styles.right} ${styles.gap}`}>
                  <PrimaryButton
                      onClick={() => {
                        toggleCsvDialog();
                      }}
                    >
                      UPLOAD
                    </PrimaryButton>
                    
                    <OutlineButton
                      onClick={() => {
                        handleSampleDownload();
                      }}
                    >
                      DOWNLOAD SAMPLE FILE
                    </OutlineButton>
                  </div>
                </div>
              </div>
            </ShadowBox>
          </div>)}
          { canReadProCode && (<div className={styles.gridContainer}>
            <ProductTable renderList={renderList} />
          </div>)}
          {(canCreateCode  || canUpdateCode ) && (<div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {" "}
                    MyDoc Code Details
                  </Typography>
                  <div className={`${styles.right} ${styles.gap}`}>
                  <PrimaryButton
                      onClick={() => {
                        toggleMyDocDialog();
                      }}
                    >
                      UPLOAD
                    </PrimaryButton>
                   <OutlineButton
                      onClick={() => {
                        handleSampleMyDocDownload();
                      }}
                    >
                      DOWNLOAD SAMPLE FILE
                    </OutlineButton>
                  </div>
                </div>
              </div>
            </ShadowBox>
          </div>)}
          { canReadCode && (<div className={styles.gridContainer}>
            <DocTable renderList={renderMyDocList} />
          </div>)}
          { canReadPetMaster && ( <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {" "}
                    Pet Details
                  </Typography>
                  {canCreatePetMaster && <ArrowPrimaryButton
                    onClick={togglePetDialog}
                    icon={<Add fontSize="normal" />}
                  >
                    ASSOCIATE PET
                  </ArrowPrimaryButton>}
                </div>
                <br />
                <ProductPetTable renderPetList={renderPetList} />
              </div>
            </ShadowBox>
          </div>)}
          { canReadQuiz && (
          <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {" "}
                    Quiz Details
                  </Typography>
                  {canCreateQuiz &&<ArrowPrimaryButton
                    onClick={handleCreate}
                    icon={<Add fontSize="normal" />}
                  >
                    ADD QUIZ
                  </ArrowPrimaryButton>}
                </div>
                <br />
                <ProductQuizTable />
              </div>
            </ShadowBox>
          </div>
          )}
          { canReadHealth && (
          <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <div className={styles.row1}>
                  <Typography
                    variant={"h5"}
                    className={styles.productHeading}
                    color={"text.primary"}
                  >
                    {" "}
                    Health Tips Details
                  </Typography>
                  {canCreateHealth &&<ArrowPrimaryButton
                    onClick={handleHealthCreate}
                    icon={<Add fontSize="normal" />}
                  >
                    ADD HEALTH TIPS
                  </ArrowPrimaryButton>}
                </div>
                <br />
                <ProductHealthTipsTable />
              </div>
            </ShadowBox>
          </div>
          )}
          { canReadReward && (
          <div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <ProductRewardTable
                  renderRewardList={renderRewardList}
                  updateRewardList={updateRewardList}
                />
              </div>
            </ShadowBox>
          </div>)}

          { canReadGift && (<div className={styles.gridContainer}>
            <ShadowBox className={styles.product}>
              <div className={styles.title}>
                <GiftStoreTable
                  renderGiftList={renderGiftList}
                  updateGiftList={updateGiftList}
                />
              </div>
            </ShadowBox>
          </div>)}
        </>
      </div>
    </div>
  );
};

export default ProgramDetail;
